import React from 'react';

import { Container } from './styles';

interface LoaderProps {
  isFixed?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ isFixed = false }) => {
  return (
    <Container isFixed={isFixed}>
      <div>
        <span />
      </div>
    </Container>
  );
};

export default Loader;
